import useSWR from "swr";
import { api } from "@/lib/api";
import Reveal from "@/components/site/Reveal";

const fetcher = (url) => api.get(url).then((r) => r.data);

/** Contributi dei lettori già approvati. Solo la firma scelta: mai l'email. */
export const ReaderIdeas = () => {
  const { data } = useSWR("/diario/idee", fetcher, { revalidateOnFocus: false });
  const items = data?.items || [];
  if (!items.length) return null;

  return (
    <div data-testid="reader-ideas">
      <p className="eyebrow text-gold">Le idee di chi legge</p>
      <ul className="mt-8 grid gap-10 md:grid-cols-2">
        {items.map((idea, i) => (
          <Reveal as="li" key={idea.id} delay={Math.min(i * 0.05, 0.3)} className="border-t border-wood/15 pt-6">
            <h3 className="font-serif text-xl leading-snug text-wood">{idea.title}</h3>
            <p className="mt-3 whitespace-pre-line text-sm leading-relaxed text-foreground/70">{idea.body}</p>
            {idea.editor_note && (
              <p className="mt-4 border-l-2 border-sage/50 pl-4 text-sm italic text-foreground/60">
                {idea.editor_note}
              </p>
            )}
            <p className="mt-4 text-xs tracking-wider text-foreground/45">{idea.display_name}</p>
          </Reveal>
        ))}
      </ul>
    </div>
  );
};

export default ReaderIdeas;
